var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 29.77 13.01" }, props),
    React.createElement("path", { d: "M.49 2.7c0-.94 1.9-1.53 3.59-1.79a33.67 33.67 0 0 1 6.34-.4 9.52 9.52 0 0 1 2.71.36c.8.26 1.42.74 1.32 1.24s-.55.71-1 1c-1.63 1-3.66 1.67-5.41 2.55s-3.28 2-3.44 3.29a.72.72 0 0 0 .2.65 3.32 3.32 0 0 0 1.62.48c5.46.56 10.79-1.15 16.31-1.48a12.6 12.6 0 0 1 3.73.2c1.14.29 2.07.91 2 1.59-.07.47-.59.9-.6 1.37s1 1 1.68.64", fill: "none", stroke: "#306f82", strokeMiterlimit: "10", strokeWidth: ".986" })
  );
});